export default "__VITE_ASSET__Bwat5miL__"